import axios from 'axios';
import {currentEnv} from '../../Utility/constants';

export const axiosInstance = axios.create({
  baseURL: `${currentEnv}`,
  /* headers: {
    'Content-Type': 'application/json',
  }, */
  timeout: 5000,
});
